<app-loading *ngIf="showLoading"></app-loading>

<div class="container">
  <div class="cooking-story-header" [ngClass]="{ searched: !isSearch }">
    <div class="header">
      <img
        src="assets/cookingbook/angle-white.svg"
        (click)="goBack()"
        class="goback icon-shadow"
        alt=""
      />
      <p class="title">افزودن غذا</p>
    </div>
    <div class="search-container">
      <div class="search-box">
        <img
          src="assets/cookingbook/search.svg"
          *ngIf="!isSearch"
          class="icon"
          alt=""
        />
        <img
          src="assets/cookingbook/search_blue.svg"
          *ngIf="isSearch"
          class="icon"
          alt=""
        />

        <input
          type="text"
          [(ngModel)]="searchText"
          (keydown)="onkeydown($event)"
          (ngModelChange)="search($event)"
          autocomplete="off"
          autofocus
          placeholder="جست و جوی غذای مورد نظر "
        />
      </div>
      <div class="cancel" (click)="cancel()">لغو</div>
    </div>
  </div>
  <div class="cooking-story-body">
    <div
      class="hint"
      *ngIf="
        mostUseShoppingList?.length == 0 &&
        shoppingListItem?.length == 0 &&
        !searched
      "
    >
      <div>
        <img src="assets/cookingbook/arrow-up.svg" alt="" />
        <p>نام غذای مورد نظر خود را وارد کنید.</p>
      </div>
    </div>
    <div *ngIf="shoppingListItem.length > 0">
      <div
        class="categorie"
        *ngFor="let item of shoppingListItem; let first = first"
      >
        <p class="categorie_title" [ngClass]="{ first: first }">
          {{ item.name }}
        </p>
        <div class="categorie_item" *ngFor="let food of item.foods">
          <div class="categorie_item_title" (click)="toggleSelect(food._id)">
            <img
              [src]="
                checkSelect(food._id)
                  ? 'assets/cookingbook/circle.svg'
                  : 'assets/cookingbook/circle_true.svg'
              "
              alt=""
            />
            <p>{{ food.name }}</p>
          </div>
          <span
            (click)="openCartBottomSheet(food, food._id)"
            *ngIf="!checkSelect(food._id)"
            >{{ checkForDefine(food._id) }}</span
          >
        </div>
      </div>
    </div>
    <div class="notfound" *ngIf="notfound">
      <p>نتیجه‌ای یافت نشد</p>
      <div (click)="quickAdd()">
        <img src="assets/plan/plus.svg" alt="" />
        <p>افرودن ''{{ searchText }}'' به لیست</p>
      </div>
    </div>
    <div
      *ngIf="mostUseShoppingList && mostUseShoppingList.length > 0 && !searched"
    >
      <div class="categorie">
        <p class="categorie_title" [ngClass]="{ first: true }">اخیراً</p>
        <div
          class="categorie_item"
          *ngFor="let item of mostUseShoppingList; let first = first"
        >
          <div class="categorie_item_title">
            <img
              (click)="toggleSelect(item._id)"
              [src]="
                checkSelect(item._id)
                  ? 'assets/cookingbook/circle.svg'
                  : 'assets/cookingbook/circle_true.svg'
              "
              alt=""
            />
            <p (click)="toggleSelect(item._id)">{{ item.foodName }}</p>
            <div class="dividar"></div>
            <span
              (click)="openCartBottomSheet(item.food, item._id)"
              *ngIf="!checkSelect(item._id)"
              >{{ checkForDefine(item._id) }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isSearch && selectedItem.length > 0 && showSelected">
      <div class="categorie_item" *ngFor="let food of getSelectedItem()">
        <div class="categorie_item_title" (click)="toggleSelect(food.id)">
          <img
            [src]="
              checkSelect(food.id)
                ? 'assets/cookingbook/circle.svg'
                : 'assets/cookingbook/circle_true.svg'
            "
            alt=""
          />
          <p>{{ food.name }}</p>
        </div>
        <span
          (click)="openCartBottomSheet(food, food.id)"
          *ngIf="!checkSelect(food.id)"
          >{{ checkForDefine(food.id) }}</span
        >
      </div>
    </div>
  </div>
  <div
    class="button"
    [ngClass]="{ active: selectedItem.length > 0 }"
    (click)="saveItems()"
  >
    افزودن<span>{{ selectedItem.length }}</span>
  </div>
</div>
